export class ViewerAppError extends Error {
  constructor(message?: string | undefined, cause?: unknown) {
    super(message, { cause })
  }
}
